import { Service, ServiceInitializer } from '@estee/elc-service';

const { name, version } = __serviceInfo__;

export class TranslationsService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}
